// Builds a GeoJSON polygon approximating a circle of `radiusMiles` around a
// [lng, lat] center — Mapbox has no native radius circle, so area listings draw
// this filled polygon. Shared by the area-map editor and the read-only show map.
export function circlePolygon(lng, lat, radiusMiles, points = 72) {
  const earthRadiusMiles = 3958.8
  const radLat = (lat * Math.PI) / 180
  const ring = []
  for (let i = 0; i <= points; i++) {
    const bearing = (i / points) * 2 * Math.PI
    // Angular distance of the radius, projected onto lat/lng degrees.
    const dLat = (radiusMiles / earthRadiusMiles) * Math.cos(bearing)
    const dLng =
      (radiusMiles / (earthRadiusMiles * Math.cos(radLat))) * Math.sin(bearing)
    ring.push([lng + (dLng * 180) / Math.PI, lat + (dLat * 180) / Math.PI])
  }
  return {
    type: "Feature",
    geometry: { type: "Polygon", coordinates: [ring] },
    properties: {},
  }
}
